/**
 * How to Use:
 * User inside modal component
 *    <LoaderComponent type='small' />
 * User loader for page
 *    <LoaderComponent type='large' />
 */
import React from 'react';
import SvgIcon from './SvgIcon';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

import { getBrandId } from '../../utils/BrandUtils';

class LoaderComponent extends React.Component {
  componentDidMount() {
    if (this.props.type === 'large') {
      this.refs['contentLoading'].focus();
      SiteHeaderActionCreator.setDisableHeaderFlag(true);
    }
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.setDisableHeaderFlag(false);
  }

  render() {
    const { type } = this.props;

    let size = '0px';
    if (this.props.type === 'small') {
      size = '24px';
    } else if (this.props.type === 'large') {
      size = '64px';
    }

    const brand = getBrandId();

    const VMBackgroundIcon = (
      <svg
        className="vm-loader__background-icon"
        height="57"
        viewBox="0 0 61 57"
        width="61"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="path"
          d="m2.21544753 51.7246823c0-16.835211 0-27.8126228 0-32.9322352 0-7.6794186 4.87996272-16.12312269 14.27500157-16.12312269 9.3950389 0 13.1763368 8.79993589 13.4538908 12.14064769.277554 3.3407119.8526419 26.3042042.8526419 31.2764604 0 4.9722561-2.7961501 7.397472-6.7411493 7.6282062-3.404661 0-5.0882574-1.9899564-5.9468688-4.1116097-.377848-.9336731-.6090522-2.8188243 0-5.1384889.2090734-.7962868.7691178-2.0882953 1.6801332-3.8760256 13.6898338-20.6443624 21.3474302-31.96297317 22.9727892-33.95583247 2.9152442-3.2929716 5.616582-3.50998926 7.3762314-3.40185161 4.9041631.04433002 6.5700975 5.19794886 6.6065571 7.95671568v40.5371362"
          fill="none"
          stroke="hsl(300, 1%, 85%)"
          strokeLinecap="square"
          strokeWidth="5"
          transform="translate(1)"
        />
      </svg>
    );

    const VMForegroundIcon = (
      <svg
        className="vm-loader__foreground-icon"
        height="57"
        viewBox="0 0 61 57"
        width="61"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="path"
          d="m2.21544753 51.7246823c0-16.835211 0-27.8126228 0-32.9322352 0-7.6794186 4.87996272-16.12312269 14.27500157-16.12312269 9.3950389 0 13.1763368 8.79993589 13.4538908 12.14064769.277554 3.3407119.8526419 26.3042042.8526419 31.2764604 0 4.9722561-2.7961501 7.397472-6.7411493 7.6282062-3.404661 0-5.0882574-1.9899564-5.9468688-4.1116097-.377848-.9336731-.6090522-2.8188243 0-5.1384889.2090734-.7962868.7691178-2.0882953 1.6801332-3.8760256 13.6898338-20.6443624 21.3474302-31.96297317 22.9727892-33.95583247 2.9152442-3.2929716 5.616582-3.50998926 7.3762314-3.40185161 4.9041631.04433002 6.5700975 5.19794886 6.6065571 7.95671568v40.5371362"
          fill="none"
          stroke="hsl(5, 88%, 47%)"
          strokeLinecap="square"
          strokeWidth="5"
          transform="translate(1)"
        />
      </svg>
    );

    const LoadingComponent =
      brand === 'VM' ? (
        <div
          className={
            type === 'small'
              ? `vm-loader ${this.props.className}`
              : 'vm-loader vm-loader--large'
          }
          ref="contentLoading"
        >
          <div>
            {VMBackgroundIcon}
            {VMForegroundIcon}
            <span>Please wait</span>
          </div>
        </div>
      ) : (
        <div
          ref="contentLoading"
          tabIndex="-1"
          className={
            this.props.type === 'small'
              ? 'spinner-loader spinner-loader--modal-loader'
              : 'spinner-loader'
          }
        >
          <span className="u-visually-hidden">Content</span>
          <div className="spinner-loader__spinner">
            <SvgIcon id="icon-refresh" width={size} height={size} />
          </div>
        </div>
      );

    return LoadingComponent;
  }
}

export default LoaderComponent;
